import {toast} from 'sonner';
import {
  analyticsInsightErrorMessage,
  useUpdateAnalyticsInsightMyState,
} from '@api/analytics-insights';
import {useUpdateWeeklyReportInsightMyState} from '@api/weekly-reports';

interface ReviewInput {
  insightSid: string;
  reviewed: boolean;
  expectedRevision: number;
  successMessage?: string;
}

/** Общая явная отметка и отмена по возвращённой revision; отзыв и задачи не меняются. */
export const useInsightReview = (reportSid: string | null = null) => {
  const mutation = useUpdateAnalyticsInsightMyState();
  const reportMutation = useUpdateWeeklyReportInsightMyState(reportSid);

  const setReviewed = async ({
    insightSid,
    reviewed,
    expectedRevision,
    successMessage,
  }: ReviewInput) => {
    const saved = await (reportSid ? reportMutation : mutation).mutateAsync({
      insightSid,
      dto: {reviewed, expectedRevision},
    });
    toast.success(
      successMessage ??
        (reviewed
          ? 'Инсайт отмечен рассмотренным'
          : 'Инсайт возвращён в список'),
      reviewed
        ? {
            action: {
              label: 'Отменить отметку',
              onClick: () =>
                setReviewed({
                  insightSid,
                  reviewed: false,
                  expectedRevision: saved.revision,
                }).catch((error) => {
                  toast.error(analyticsInsightErrorMessage(error));
                }),
            },
          }
        : undefined,
    );
    return saved;
  };

  return {
    setReviewed,
    isPending: reportSid ? reportMutation.isPending : mutation.isPending,
  };
};
